import { createSection } from '@formkit/inputs'

/**
 * Tab section, holds a group of tabs
 *
 * @public
 */
export const tabs = createSection('tabs', () => ({
  $el: 'div',
  attrs: {
    role: 'tablist',
  },
}))
